export default __webpack_public_path__ + "static/media/icon1.9a2a2b6c.png";